import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FileDetails } from '../shared/models/file-details.model';
import { GlobalsService } from '../shared/services/globals.service';
export class ViewUploadLoaderComponent implements OnInit {

   onFileSelected: EventEmitter<FileDetails> = new EventEmitter<FileDetails>();

  selectedXML: FileDetails;
/**
 * @param {?} globalsService
 */
constructor(private globalsService: GlobalsService) {

  }
/**
 * @return {?}
 */
ngOnInit(): void {
    const /** @type {?} */ hellowRadsFileContent = document.getElementById('HellowRadsModule').innerText;
    const /** @type {?} */ helloRadsModule = new FileDetails('Hello_RADS', 'Hello_RADS.xml', hellowRadsFileContent);
    this.globalsService.XMLList.Add(helloRadsModule.fileLabel, helloRadsModule);
    this.selectedXML = helloRadsModule;
    this.onFileSelected.emit(helloRadsModule);
  }
/**
 * @param {?} fileDetails
 * @return {?}
 */
onFileContentRead(fileDetails: FileDetails) {
    this.selectedXML = fileDetails;
    if (this.globalsService.XMLList.ContainsKey(fileDetails.fileLabel)) {
      this.globalsService.XMLList.Remove(fileDetails.fileLabel);
    }
    this.globalsService.XMLList.Add(fileDetails.fileLabel, fileDetails);
    this.onFileSelected.emit(fileDetails);
  }
/**
 * @param {?} fileDetails
 * @return {?}
 */
onFileClick(fileDetails: FileDetails) {
    this.selectedXML = fileDetails;
    this.onFileSelected.emit(fileDetails);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'acr-view-upload-loader',
  template: `

      <ul class="nav nav-sidebar">
        <li class="header">Want to try your assist module?</li>
    
        <li class="fileUploader">
          <acr-file-upload-loader (onFileContentRead)="onFileContentRead($event)"></acr-file-upload-loader>
        </li>
      </ul>
      <ul class="nav nav-sidebar">
        <li class="header">ACR Assist Modules</li>

        <li [ngClass]="{'active':(selectedXML != 'undefined' && selectedXML.fileLabel == file.fileLabel)}" *ngFor="let file of globalsService.XMLList.Values().reverse()">
            <a href="#" (click)="onFileClick(file)">{{file.fileLabel}}</a>
    
        </li>

      </ul>
  `,
  styles: [`

    /* Sidebar navigation */

    .nav-sidebar {
      margin-right: -21px;
      /* 20px padding + 1px border */
      /* margin-bottom: 20px; */
      margin-left: -20px;
    }

    .nav-sidebar>li>a {
      padding-right: 20px;
      padding-left: 20px;
      color: #b8c7ce;
      border-left: 3px solid transparent;
    }

    .nav-sidebar>.active>a {
      border-left-color: #1e89b5 ;
    }

    .nav-sidebar>.active>a,
    .nav-sidebar>.active>a:hover,
    .nav-sidebar>.active>a:focus,
    .nav-sidebar>li>a:hover {
      color: #fff;
      background-color: #1e282c;
    }
    .nav-sidebar>li.fileUploader {
  
      padding: 10px 25px 1px 15px;
      font-size: 12px;
    }
    .nav-sidebar>li.header {
      color:#899ca5;
      background: #1a2226;
      padding: 10px 25px 10px 15px;
      font-size: 13px;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: GlobalsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onFileSelected': [{ type: Output },],
};
}

function ViewUploadLoaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
ViewUploadLoaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ViewUploadLoaderComponent.ctorParameters;
/** @type {?} */
ViewUploadLoaderComponent.propDecorators;
/** @type {?} */
ViewUploadLoaderComponent.prototype.onFileSelected;
/** @type {?} */
ViewUploadLoaderComponent.prototype.selectedXML;
/** @type {?} */
ViewUploadLoaderComponent.prototype.globalsService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
